import { Button, TextField, FormLabel, styled, InputAdornment, IconButton, CircularProgress, Modal, Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { developerLogin, forgotPasswordApi, updatePasswordApi, } from "../../dev_services/developer/api";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { devloggedIn } from "../../dev_store/slice/devAuthSlice";
import "../../dev_pages/auth/dev_login.scss";
import { googleIcon, phoneIcon, devbglogo} from "../../../assets";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { cross } from '../../../assets';

// Define the modal style
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid purpel',
  boxShadow: 24,
  p: 4,
};

const DeveloperLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword1, setShowConfirmPassword1] = useState(false);
const [showConfirmPassword2, setShowConfirmPassword2] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [openForgotPassword, setOpenForgotPassword] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [openResetPassword, setOpenResetPassword] = useState(false);
  const [resetPasswordValues, setResetPasswordValues] = useState({
    email: '',
    otp: '',
    password: '',
    password_confirm: '',
  });

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const togglePasswordConfirmVisibility1 = () => {
    setShowConfirmPassword1((prevShowPassword) => !prevShowPassword);
  };
  const togglePasswordConfirmVisibility2 = () => {
    setShowConfirmPassword2((prevShowPassword) => !prevShowPassword);
  };
  useEffect(() => {
    console.log("Form values updated:", formValues);
  }, [formValues]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await developerLogin(formValues);
      if (response.token !== null) {
        toast.success("Login Successfully");
        dispatch(devloggedIn({
          developer_token: response.token,
          dev_partner_id: response.partner_id,
          dev_refresh_token: response.refresh_token,
          dev_email_verified: response.email_verified,
          developer_id: response.developer_id,
          dev_first_name: response.first_name,
          dev_last_name: response.last_name,
          dev_email: response.email,
        }));
        navigate('/developer');
      } else {
        const errorMessage = response && response.data && response.data.error ? response.data.error : 'Unknown error occurred';
        console.error('Login failed:', errorMessage);
        toast.error(errorMessage);
      }
    } catch (error: any) {
      console.error('Error:', error.message);
      toast.error(error.error);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    try {

      const data = { email: forgotPasswordEmail }
      const response = await forgotPasswordApi(data);

      if (response.data) {
        toast.success(response.data.message);
        setOpenForgotPassword(false);
        setOpenResetPassword(true);
        setResetPasswordValues({ ...resetPasswordValues, email: forgotPasswordEmail });
      } else {
        const errorMessage = response && response.data && response.data.error ? response.data.error : 'Unknown error occurred';
        console.error('Forgot password failed:', errorMessage);
        toast.error(errorMessage);
      }
    } catch (error: any) {
      console.error('Error:', error.message);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };


  ///OTP UI call
  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    try {

      const response = await updatePasswordApi(resetPasswordValues);

      if (response.data) {
        toast.success(response.data.message);
        setOpenResetPassword(false);
      } else {
        const errorMessage = response && response.data && response.data.error ? response.data.error : 'Unknown error occurred';
        console.error('Reset password failed:', errorMessage);
        toast.error(errorMessage);
      }
    } catch (error: any) {
      console.error('Error:', error.message);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex justify-center bg-gray-200 bgg-img">
      <div className="max-w-xl w-full">
        <div className="text-center mt-lg-5 mt-md-4 mt-10">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <a href="#">
              <img src={devbglogo} alt="Image" width="250px" height="231px" className="block-center srrlogo mt-5 mt-lg-0" />
            </a>
          </div>
        </div>

        <ToastContainer />
        <div style={{ borderRadius: "15px", width: "100%", paddingLeft: "40px", paddingRight: "40px" }} className="bg-white px-2rem px-md-4 mb-md-3 py-md-3 pb-lg-4 p-4 mb-3 mt-8">
          <form onSubmit={handleSubmit}>
            <h3 style={{ fontFamily: "sfprobold", fontSize: "20px" }} className="text-center fs-20px mt-2 mt-md-3 mb-4 font-weight-bold">Login To App Store Partner&apos;s Account</h3>
            {/* <div style={{ justifyContent: "center", gap: "20px" }} className="row d-none d-md-flex mt-15">
              <div className="col-md-4 col-6 pr-sm">
                <a className="btn btn-block btn-social btn-border">
                  <div className="img-container">
                    <img src={googleIcon} alt="Google" width="20px" height="20px" className="w-20px" />
                    <span style={{ fontFamily: "sfpromedium" }} className="text-right">Google</span>
                  </div>
                </a>
              </div>
              <div className="col-md-4 col-6 pr-sm">
                <a className="btn btn-block btn-social btn-border">
                  <div className="img-container">
                    <img src={phoneIcon} alt="Phone" width="20px" height="20px" className="w-20px" />
                    <span style={{ fontFamily: "sfpromedium" }}>Phone No</span>
                  </div>
                </a>
              </div>
            </div>

            <div className="text-center pv">
              <p style={{ fontFamily: "sfpromedium", fontSize: "16px" }} className="my-1 text-center fs-16px">
                <span className="dashed-border mb-2px"></span>or <span className="dashed-border mb-2px"></span>
              </p>
            </div> */}

            <div className="mb-3">
              <label htmlFor="email" className="block">Email ID</label>
              <input
                style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                type="email"
                id="email"
                placeholder="Enter your email"
                name="email"
                value={formValues.email}
                onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="block">Password</label>
              <input
                style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                id="password"
                name="password"
                value={formValues.password}
                onChange={(e) => setFormValues({ ...formValues, password: e.target.value })}
                required
              />
              <InputAdornment style={{ paddingTop: "2px", paddingRight: "20px", alignItems: "flex-end", justifyContent: "flex-end" }} position="end">
                <IconButton onClick={togglePasswordVisibility} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            </div>

            <button style={{ color: "#745be7" }} type="button" onClick={() => setOpenForgotPassword(true)}>Forgot Password?</button>
            <br />
            {isLoading ? (
              <div style={{ textAlign: "center" }}>
                <CircularProgress color="inherit" size={24} />
              </div>
            ) : (
              <button
                style={{ fontFamily: "sfpromedium" }}
                type="submit"
                className="mt-lg-4 btn btn-bg-blue rounded-10px col-md-12 h-40px fs-14px text-light font-weight-bold mt-4 mt-lg-0"
              >
                Login
              </button>
            )}
            <div className="centered col-md-12 col-xs-12 font-14 mt-3" style={{ color: '#969696', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span>New to App Store?</span>
              <button style={{ marginLeft: '7px', color: '#745be7' }} onClick={() => navigate('/developer/signup')} color="primary">
                Sign Up
              </button>
            </div>
          </form>
        </div>

        {/* Forgot Password Modal */}
        <Modal
          open={openForgotPassword}
          onClose={() => setOpenForgotPassword(false)}
          aria-labelledby="forgot-password-modal-title"
          aria-describedby="forgot-password-modal-description"
        >

          <Box sx={modalStyle}>
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                padding: '5px',
              }}
            >
              <img
                style={{ width: '40px', cursor: 'pointer' }}
                src={cross}
                alt="Close Icon"
                onClick={() => setOpenForgotPassword(false)}
              />
            </div>
            <form onSubmit={handleForgotPasswordSubmit}>
              <p id="forgot-password-modal-description">Enter your email to receive password reset instructions.</p>
              <br />
              <div className="mb-3">
                <label htmlFor="forgotPasswordEmail" className="block">Email ID</label>
                <input
                  style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                  type="email"
                  id="forgotPasswordEmail"
                  placeholder="Enter your email"
                  name="forgotPasswordEmail"
                  value={forgotPasswordEmail}
                  onChange={(e) => setForgotPasswordEmail(e.target.value)}
                  required
                />
              </div>
              <button
                style={{ fontFamily: "sfpromedium" }}
                type="submit"
                className="mt-lg-4 btn btn-bg-blue rounded-10px col-md-12 h-40px fs-14px text-light font-weight-bold mt-4 mt-lg-0"
              >
                Submit
              </button>
            </form>
          </Box>
        </Modal>

        {/* Reset Password Modal */}
        <Modal
          open={openResetPassword}
          onClose={() => setOpenResetPassword(false)}
          aria-labelledby="reset-password-modal-title"
          aria-describedby="reset-password-modal-description"
        >
          <Box sx={modalStyle}>
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                padding: '5px',
              }}
            >
              <img
                style={{ width: '40px', cursor: 'pointer' }}
                src={cross}
                alt="Close Icon"
                onClick={() => setOpenResetPassword(false)}
              />
            </div>
            <form onSubmit={handleResetPasswordSubmit}>
              <p id="reset-password-modal-description">Enter the OTP and your new password.</p>
              <br />
              <div className="mb-3">
                <label htmlFor="resetPasswordEmail" className="block">Email ID</label>
                <input
                  style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                  type="email"
                  id="resetPasswordEmail"
                  placeholder="Enter your email"
                  name="resetPasswordEmail"
                  value={resetPasswordValues.email}
                  onChange={(e) => setResetPasswordValues({ ...resetPasswordValues, email: e.target.value })}
                  required
                  disabled
                />
              </div>
              <div className="mb-3">
                <label htmlFor="otp" className="block">OTP</label>
                <input
                  style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                  type="text"
                  id="otp"
                  placeholder="Enter the OTP"
                  name="otp"
                  value={resetPasswordValues.otp}
                  onChange={(e) => setResetPasswordValues({ ...resetPasswordValues, otp: e.target.value })}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="newPassword" className="block">New Password</label>
                <input
                  style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                  type={showConfirmPassword1 ? "text" : "password"}
              
                  id="newPassword"
                  placeholder="Enter your new password"
                  name="newPassword"
                  value={resetPasswordValues.password}
                  onChange={(e) => setResetPasswordValues({ ...resetPasswordValues, password: e.target.value })}
                  required
                />
                  <InputAdornment style={{ paddingTop: "2px", paddingRight: "20px", alignItems: "flex-end", justifyContent: "flex-end" }} position="end">
                <IconButton onClick={togglePasswordConfirmVisibility1} edge="end">
                  {showConfirmPassword1? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
              </div>
              <div className="mb-3">
                <label htmlFor="confirmPassword" className="block">Confirm Password</label>
                <input
                  style={{ borderRadius: "5px", height: "36px", width: "100%", borderWidth: "1px", padding: "10px" }}
                  type={showConfirmPassword2 ? "text" : "password"}
                  id="password_confirm"
                  placeholder="Confirm your new password"
                  name="password_confirm"
                  value={resetPasswordValues.password_confirm}
                  onChange={(e) => setResetPasswordValues({ ...resetPasswordValues, password_confirm: e.target.value })}
                  required
                />
                    <InputAdornment style={{ paddingTop: "2px", paddingRight: "20px", alignItems: "flex-end", justifyContent: "flex-end" }} position="end">
                <IconButton onClick={togglePasswordConfirmVisibility2} edge="end">
                  {showConfirmPassword2? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
              </div>
              <button
                style={{ fontFamily: "sfpromedium" }}
                type="submit"
                className="mt-lg-4 btn btn-bg-blue rounded-10px col-md-12 h-40px fs-14px text-light font-weight-bold mt-4 mt-lg-0"
              >
                Reset Password
              </button>
            </form>
          </Box>
        </Modal>
      </div>
    </div>
  );
};

export default DeveloperLogin;
